import { calcDrawableChartMode } from '@aytm/app/stats/page/question-views/components/lib/chart-modes'

export const getChartModeTypes = (viewMode, answer, rType, percentsOnly = false, isTraitType = false, trait = null) => {
  const isRType = rType != null && rType !== 'cases'

  if (['stacked', 'boxScore'].includes(viewMode)) {
    return ['percents', 'bpercents']
  }

  if (viewMode === 'area') {
    return []
  }

  if (isRType || percentsOnly) {
    return ['percents', 'bpercents']
  }

  if (
    ['score', 'meanScore', 'stackedCounts'].includes(viewMode) ||
    answer?.hasNegativeScores ||
    (isTraitType && trait != null)
  ) {
    return ['respondents', 'brespondents']
  }

  return ['pie', 'respondents', 'brespondents']
}

// the type's own rules; the exported resolver then fits the result to the modes the view offers
const calcPreferredChartMode = (chartMode, viewMode, answer, rType, globalChartMode = null, percentsOnly = false) => {
  const isRType = rType != null && rType !== 'cases'

  let mode = chartMode === 'off' ? globalChartMode : chartMode
  mode = mode || globalChartMode

  if (['stacked', 'boxScore'].includes(viewMode)) {
    if (!['percents', 'bpercents'].includes(mode)) {
      return 'percents'
    }
    return mode
  }

  if (viewMode === 'area') {
    return mode
  }

  if (isRType || percentsOnly) {
    if (!['percents', 'bpercents'].includes(mode)) {
      return 'percents'
    }
    return mode
  }

  if (['score', 'meanScore', 'stackedCounts'].includes(viewMode) || answer?.hasNegativeScores) {
    if (!['respondents', 'brespondents'].includes(mode)) {
      return 'respondents'
    }
    return mode
  }

  if (!['pie', 'respondents', 'brespondents'].includes(mode)) {
    return 'respondents'
  }

  return mode
}

// an active trait takes the pie away, so a question's own pie is drawn as the nearest mode it offers
export const getDefaultChartMode = (
  chartMode,
  viewMode,
  answer,
  rType,
  globalChartMode = null,
  percentsOnly = false,
  isTraitType = false,
  trait = null
) =>
  calcDrawableChartMode(
    calcPreferredChartMode(chartMode, viewMode, answer, rType, globalChartMode, percentsOnly),
    getChartModeTypes(viewMode, answer, rType, percentsOnly, isTraitType, trait),
    { globalChartMode }
  )
